// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[fn-hover-open][data-v-12ebeace]:hover{height:auto;z-index:999}.fn-content-8__controlbar__item[data-v-12ebeace]{position:relative;min-height:49PX}.fn-c8-explanation[data-v-12ebeace]{position:absolute;z-index:1;width:calc(100% - 32PX)}", ""]);
// Exports
module.exports = exports;
